module.exports = __webpack_public_path__ + "static/media/icon_contains.0b4f20bc.svg";